import {
    Box,
    Checkbox,
    FormControlLabel,
    Typography,
    Button,
    TextField,
    InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import themeColors from "../theme";

export default function MarketplaceFilters({
    subcategories,
    selectedSubcategories,
    onToggleSubcategory,
    onClearFilters,
    subSearchQuery,
    setSubSearchQuery,
    filterTitle = "Filter Books",
}) {
    const { teal, darkTeal } = themeColors;

    const filteredSubcategories = subcategories.filter((cat) =>
        cat.toLowerCase().includes(subSearchQuery.toLowerCase())
    );

    return (
        <Box
            sx={{
                backgroundColor: "white",
                borderRadius: 2,
                border: "1px solid #e0e8ea",
                p: 2.5,
                height: "fit-content",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            }}
        >
            <Typography
                variant="h6"
                fontWeight={700}
                color="#2C3E50"
                sx={{ mb: 2 }}
            >
                {filterTitle}
            </Typography>

            {/* Search within filters */}
            <TextField
                size="small"
                fullWidth
                placeholder="Search CME..."
                value={subSearchQuery}
                onChange={(e) => setSubSearchQuery(e.target.value)}
                sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        backgroundColor: "#f5f7f8",
                        "& fieldset": { borderColor: "#ddd" },
                    },
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ color: "#999", fontSize: 20 }} />
                        </InputAdornment>
                    ),
                }}
            />

            <Typography
                variant="subtitle2"
                fontWeight={700}
                color="#2C3E50"
                sx={{ mb: 1 }}
            >
                Categories
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: 400,
                    overflowY: "auto",
                    "&::-webkit-scrollbar": { width: 4 },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#ccc",
                        borderRadius: 2,
                    },
                }}
            >
                {filteredSubcategories.map((cat) => (
                    <FormControlLabel
                        key={cat}
                        sx={{
                            ml: 0,
                            mr: 0,
                            py: 0.2,
                            "& .MuiFormControlLabel-label": {
                                fontSize: "0.875rem",
                                color: "#444",
                            },
                        }}
                        control={
                            <Checkbox
                                checked={selectedSubcategories.includes(cat)}
                                onChange={() => onToggleSubcategory(cat)}
                                size="small"
                                sx={{
                                    color: "#ccc",
                                    "&.Mui-checked": {
                                        color: teal,
                                    },
                                    py: 0.4,
                                }}
                            />
                        }
                        label={cat}
                    />
                ))}
            </Box>

            <Button
                fullWidth
                variant="contained"
                onClick={onClearFilters}
                sx={{
                    mt: 2,
                    background: `linear-gradient(135deg, ${teal}, ${darkTeal})`,
                    color: "white",
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: 2,
                    py: 1,
                    "&:hover": {
                        background: `linear-gradient(135deg, ${darkTeal}, ${teal})`,
                    },
                }}
            >
                Clear Filters
            </Button>
        </Box>
    );
}
